// Components.
import './components/nav';
// @TODO Commented out loadmore/infinite scroll feature, we can uncomment this once we have more than 30 case studies.
// import './components/loadmore/case-studies';
import './components/forms';
import './components/trackslider';
import './components/ticker';
import Typed from 'typed.js';
import Sticky from 'sticky-js';

// Styles
import '../sass/main.scss';

// Images.
import '../img/art-media-text.png';
import '../img/media-text-shadow.png';
import '../img/map-background.png';

// SVG.
import '../img/svgs/down-arrow-white.svg';
import '../img/svgs/down-arrow-white-large.svg';
import '../img/svgs/down-arrow-gray.svg';
import '../img/svgs/close-icon-white.svg';
import '../img/svgs/clip-art-cover-hero.svg';
import '../img/svgs/c-icon.svg';
import '../img/svgs/search-icon.svg';
import '../img/svgs/default-image.svg';
import '../img/svgs/arrow-down-circle.svg';
import '../img/svgs/arrow-right-blue.svg';
import '../img/svgs/arrow-right-black.svg';
import '../img/svgs/left-media-text-default.svg';


document.addEventListener("DOMContentLoaded", () => {

    const width = window.innerWidth;

    const typed = document.querySelector( '#typed-word' );
    if( null !== typed ) {
        new Typed(typed, {
            strings: [ 'Faster^100', 'Smarter^100', 'B^80e^160t^30t^40e^50r'],
            typeSpeed: 60,
            backSpeed: 30,
            onStringTyped: (arrayPos, self) => {
                if ( 1 === arrayPos ) {
                    let video = document.getElementById('hero-home-video');
                    if ( video ) {
                        if ( 599 >= width ) return;
                        
                        setTimeout(() => {
                            let videoCover = document.getElementById('video-cover');
                            if ( videoCover ) {
                                videoCover.classList.add('fade-out');
                            }
                            video.play();
                        }, 1100);
                    }
                }
            },
        });
    }

    let stickyEl = document.querySelector('.sticky-aside');

    if ( stickyEl ) {
        let sticky = new Sticky('.sticky-aside');
    }
});
